import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInGuestMutationVariables = Types.Exact<{
  guestUuid: Types.Scalars['String']['input'];
}>;


export type SignInGuestMutationPage = { readonly __typename?: 'RootMutationType', readonly signInGuest: { readonly __typename?: 'AccountsSignIn', readonly authToken?: { readonly __typename?: 'AccountsAuthToken', readonly token: string, readonly type: Types.AccountsAuthTokenType, readonly user: { readonly __typename?: 'AccountsUser', readonly id: string, readonly uuid: string, readonly phone?: string | null, readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly type?: Types.AccountsUserType | null, readonly insertedAt: string, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null } | null } } | null } };


export const SignInGuestDocument = gql`
    mutation SignInGuest($guestUuid: String!) {
  signInGuest(guestUuid: $guestUuid) {
    authToken {
      token
      type
      user {
        id
        uuid
        phone
        roles
        type
        insertedAt
        profile {
          name
        }
      }
    }
  }
}
    `;
export type SignInGuestMutationFn = Apollo.MutationFunction<SignInGuestMutationPage, SignInGuestMutationVariables>;

/**
 * __useSignInGuestMutation__
 *
 * To run a mutation, you first call `useSignInGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInGuestMutation, { data, loading, error }] = useSignInGuestMutation({
 *   variables: {
 *      guestUuid: // value for 'guestUuid'
 *   },
 * });
 */
export function useSignInGuestMutation(baseOptions?: Apollo.MutationHookOptions<SignInGuestMutationPage, SignInGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInGuestMutationPage, SignInGuestMutationVariables>(SignInGuestDocument, options);
      }
export type SignInGuestMutationHookResult = ReturnType<typeof useSignInGuestMutation>;
export type SignInGuestMutationResult = Apollo.MutationResult<SignInGuestMutationPage>;
export type SignInGuestMutationOptions = Apollo.BaseMutationOptions<SignInGuestMutationPage, SignInGuestMutationVariables>;